export function setInspectionList(state, payload) {
    state.inspectionList = payload || [];
}

export function setInspectionReportState(state, payload) {
    state.inspectionReportState = payload;
}



// WEBPACK FOOTER //
// ./src/modules/inspection-report/mutations.js